// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { RequirePermission } from "@/components/shared/require-permission";
import { SsoList } from "@/features/iam/sso-list";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/iam/sso/")({
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.iamSso}>
      <SsoList />
    </RequirePermission>
  ),
});
